import { FC } from 'react';
import { TextInput, NumberInput } from '@mantine/core';
import { ReactComponent as IconClose } from 'assets/img/close.svg';
import { ReactComponent as IconSearch } from '../img/iconSearch.svg';
import { ReactComponent as IconRuble } from '../img/iconRuble.svg';

import styles from './EmployedsFilterInput.module.scss';

export interface FilterInputProps {
  type?: 'text' | 'number' | 'search';
  value: string | number;
  onChange: (value: string | number) => void;
  placeholder?: string;
  variant?: 'default' | 'compact';
  min?: number;
  max?: number;
  className?: string;
  summary?: string[];
  onDeleteSummary?: (item: string) => void;
  show?: boolean;
  hideSearchIcon?: boolean;
}

export const EmployedsFilterInput: FC<FilterInputProps> = ({
  type = 'text',
  value,
  onChange,
  placeholder,
  variant = 'default',
  min,
  max,
  className,
  show,
  hideSearchIcon = false,
}) => {
  const inputClass = variant === 'compact' ? styles.compactInput : styles.input;
  const searchClass = type === 'search' ? styles.searchInput : inputClass;

  const handleClearInput = () => {
    onChange('');
  };

  if (type === 'number') {
    return (
      <div style={{ position: 'relative' }}>
        {!value && !hideSearchIcon && <IconSearch className={styles.searchIcon} />}
        <NumberInput
          value={value}
          onChange={(val) => onChange(val || '')}
          placeholder={placeholder}
          min={min}
          max={max}
          hideControls
          className={`${inputClass} ${className || ''}`}
          styles={{
            input: {
              paddingLeft: value || hideSearchIcon ? '12px' : '40px',
              paddingRight: show ? '30px' : '12px',
              background: '#fff',
            },
          }}
        />
        {show && (
          <IconRuble
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              pointerEvents: 'none',
            }}
          />
        )}
      </div>
    );
  }

  if (type === 'search') {
    return (
      <div className={styles.searchWrapper}>
        {!value && <IconSearch className={styles.searchIcon} />}
        <input
          type='text'
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`${searchClass} ${className || ''}`}
          style={{
            paddingLeft: value ? '12px' : '40px',
            paddingRight: show ? '30px' : '12px',
          }}
        />
        {value && <IconClose className={styles.closeIcon} onClick={handleClearInput} />}
      </div>
    );
  }

  return (
    <div style={{ position: 'relative' }}>
      {!value && <IconSearch className={styles.searchIcon} />}
      <TextInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`${inputClass} ${className || ''}`}
        styles={{
          input: {
            paddingLeft: value ? '12px' : '40px',
            paddingRight: show ? '30px' : '12px',
          },
        }}
      />
      {value && <IconClose className={styles.closeIcon} onClick={handleClearInput} />}
    </div>
  );
};
